// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.viewStudent_modalOverlay__X7kcC {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  z-index: 1300;
  animation: viewStudent_fadeIn__0\\+non 0.3s ease-out;
}

/* Modal Content */
.viewStudent_modalContent__ernub {
  /* width: 40%; */
  max-width: 700px;
  min-width: 500px;
  background-color: white;
  height: 100vh;
  overflow-y: auto;
  position: relative;
  animation: viewStudent_slideInRight__LtMpm 0.3s ease-out;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  padding-bottom: 80px; /* Add space for the sticky button */
  display: flex;
  flex-direction: column;
  border-radius: 16px 0 0 0px;
}

.viewStudent_remarkParent__o71Cs {
  margin: 16px 24px;
  padding: 16px 24px;
  border-radius: 16px;
  border: 1px solid var(--Slate-200, #e2e8f0);
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100% !important;
  margin-bottom: 30px;
}

/* Slide Animation */
@keyframes viewStudent_slideInRight__LtMpm {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes viewStudent_fadeIn__0\\+non {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Header */
.viewStudent_modalHeader__WQ9UO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.viewStudent_modalTitle__WOhH2 {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  font-family: 'Inter', sans-serif;
}
.viewStudent_statusSection__Wlc6y {
  display: flex;
  gap: 12px;
  align-items: center;
}

.viewStudent_headerRight__qBhjF {
  display: flex;
  align-items: center;
  gap: 16px;
}

.viewStudent_statusChip__UMX6h {
  font-weight: 600;
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
  font-size: 12px;
  padding: 4px 12px;
  text-transform: capitalize;
}

.viewStudent_closeButton__rMkOz {
  color: #6b7280;
  transition: all 0.2s ease;
}

.viewStudent_closeButton__rMkOz:hover {
  color: #374151;
  background-color: #f3f4f6;
}

/* Student Overview Section */
.viewStudent_studentOverview__97H\\+r {
  padding: 24px;
}

.viewStudent_avatarSection__gYI4B {
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background: var(--Violet-50, #f5f3ff);
  padding: 12px 16px;
}

.viewStudent_studentAvatar__oN2ft {
  width: 32px;
  height: 32px;
  color: var(--Gray-800, #1f2937);
  text-align: center;

  /* Inter/Body small/Body small - semibold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
}

.viewStudent_studentInfo__7bh2A {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 290px;
}

.viewStudent_studentInfoBottom__Ft2jx {
  display: flex;

  gap: 24px;
  margin-top: 6px;
}

.viewStudent_studentName__iBqdg {
  color: var(--Gray-800, #1f2937);

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  font-family: 'Inter', sans-serif;
}

.viewStudent_studentEmail__ZvxGh,
.viewStudent_studentMobile__H4\\+qK {
  font-size: 14px;
  color: #6b7280;
  font-family: 'Inter', sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;
}

.viewStudent_studentEmail__ZvxGh svg,
.viewStudent_studentMobile__H4\\+qK svg {
  flex-shrink: 0;
}

/* Details Section */
.viewStudent_detailsSection__imrcr {
  margin: 8px 24px;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid var(--Slate-200, #e2e8f0);
}

.viewStudent_sectionHeader__VvQwu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.viewStudent_sectionTitle__Skoa1 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  font-family: 'Inter', sans-serif;
}

.viewStudent_relocateButton__3Civx {
  color: var(--Violet, #644ee5);
  text-align: center;

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  background-color: #f5f3ff;
  border: 1px solid var(--Violet-200, #c7d2fe);
  border-radius: 8px;
  border: 1px solid var(--Violet, #644ee5);
  box-shadow: none !important;
}

.viewStudent_relocateButton__3Civx:hover {
  background-color: #644ee5;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: none;
}

/* Details Grid */
.viewStudent_detailsGrid__UouZU {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 12px;
}

.viewStudent_detailItem__hooCh {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  padding: 12px 0;
  width: 289px;
}

.viewStudent_detailItem__hooCh:last-child {
  border-bottom: none;
}

.viewStudent_detailLabel__4KrYk {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
}

.viewStudent_detailDescription__n9w-m {
  width: 100%;
}
.viewStudent_detailValue__ccZlt {
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
  line-height: 20px;
  font-family: 'Inter', sans-serif;
}
.viewStudent_attachmentContainer__NVnfO {
  width: 100%;

  border-radius: 12px;
  background: #f1eeff;
  display: flex;
  min-width: 175px;
  padding: 12px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  display: flex;
  align-items: center;
  margin-top: 6px;
}

.viewStudent_detailsNameGrid__pn2z0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Action Button Container - NEW STYLES ONLY */
.viewStudent_actionButtonContainer__71Ytt {
  padding: 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  display: flex;
  justify-content: flex-end;
}

.viewStudent_resolveButton__BqSId {
  background-color: #644ee5 !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-family: 'Inter', sans-serif !important;
  transition: all 0.2s ease !important;
}

.viewStudent_resolveButton__BqSId:hover {
  background-color: #644ee5 !important;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3) !important;
}

/* Actions Container - Sticky Bottom */
.viewStudent_actionsContainer__l-te0 {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 676px;
  max-width: 700px;
  min-width: 500px;
  padding: 24px;
  background-color: white;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  z-index: 10;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
.viewStudent_attachmentWrapper__WD1U6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.viewStudent_attachmentIcon__rX0OS {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-block;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .viewStudent_modalContent__ernub {
    /* width: 50%; */
    min-width: 350px;
  }
}

@media (max-width: 768px) {
  .viewStudent_modalContent__ernub {
    width: 100%;
    min-width: 100%;
  }

  .viewStudent_modalHeader__WQ9UO {
    padding: 20px 20px 16px 20px;
  }
  .viewStudent_avatarSection__gYI4B {
    justify-content: center;
  }
  .viewStudent_avatarSection__gYI4B > div {
    width: 50%;
  }

  .viewStudent_studentOverview__97H\\+r,
  .viewStudent_detailsSection__imrcr {
    padding: 20px;
  }
  .viewStudent_detailsNameGrid__pn2z0 {
    justify-content: flex-start;
    /* gap; */
  }
  .viewStudent_detailsNameGrid__pn2z0 > div {
    width: 50%;
  }
  .viewStudent_studentInfo__7bh2A {
    min-width: 0;
  }
  /* .avatarSection {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  } */
  .viewStudent_detailItem__hooCh {
    width: auto;
  }
  .viewStudent_actionsContainer__l-te0 {
    width: 100%;
    max-width: unset;
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .viewStudent_modalHeader__WQ9UO {
    padding: 16px 16px 12px 16px;
  }
  .viewStudent_detailValue__ccZlt {
    word-wrap: break-word;
  }
  .viewStudent_detailsGrid__UouZU {
    gap: 0;
    /* margin-top: 0; */
  }
  .viewStudent_studentOverview__97H\\+r,
  .viewStudent_detailsSection__imrcr {
    padding: 16px;
  }

  .viewStudent_resolveButton__BqSId {
    padding: 12px 18px;
  }

  .viewStudent_detailsNameGrid__pn2z0 > div {
    width: 45%;
  }

  .viewStudent_modalTitle__WOhH2 {
    font-size: 20px;
  }

  .viewStudent_sectionTitle__Skoa1 {
    font-size: 16px;
  }
  .viewStudent_detailsNameGrid__pn2z0 {
    align-items: flex-start;
    justify-content: space-between;
  }
  .viewStudent_studentName__iBqdg {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminDashboard/Hospital_Complaint/components/viewStudent.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,mDAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wDAAqC;EACrC,2CAA2C;EAC3C,oBAAoB,EAAE,oCAAoC;EAC1D,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;;EAElB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;;EAEb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;;EAE/B,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;;EAElB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,WAAW;;EAEX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;;EAEA;;IAEE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;;;KAGG;EACH;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,MAAM;IACN,mBAAmB;EACrB;EACA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Modal Overlay */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n  z-index: 1300;\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Modal Content */\n.modalContent {\n  /* width: 40%; */\n  max-width: 700px;\n  min-width: 500px;\n  background-color: white;\n  height: 100vh;\n  overflow-y: auto;\n  position: relative;\n  animation: slideInRight 0.3s ease-out;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  padding-bottom: 80px; /* Add space for the sticky button */\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px 0 0 0px;\n}\n\n.remarkParent {\n  margin: 16px 24px;\n  padding: 16px 24px;\n  border-radius: 16px;\n  border: 1px solid var(--Slate-200, #e2e8f0);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100% !important;\n  margin-bottom: 30px;\n}\n\n/* Slide Animation */\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Header */\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n}\n\n.modalTitle {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1f2937;\n  font-family: 'Inter', sans-serif;\n}\n.statusSection {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.headerRight {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.statusChip {\n  font-weight: 600;\n  /* text-transform: uppercase; */\n  letter-spacing: 0.5px;\n  font-size: 12px;\n  padding: 4px 12px;\n  text-transform: capitalize;\n}\n\n.closeButton {\n  color: #6b7280;\n  transition: all 0.2s ease;\n}\n\n.closeButton:hover {\n  color: #374151;\n  background-color: #f3f4f6;\n}\n\n/* Student Overview Section */\n.studentOverview {\n  padding: 24px;\n}\n\n.avatarSection {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border-radius: 8px;\n  background: var(--Violet-50, #f5f3ff);\n  padding: 12px 16px;\n}\n\n.studentAvatar {\n  width: 32px;\n  height: 32px;\n  color: var(--Gray-800, #1f2937);\n  text-align: center;\n\n  /* Inter/Body small/Body small - semibold */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 142.857% */\n}\n\n.studentInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 290px;\n}\n\n.studentInfoBottom {\n  display: flex;\n\n  gap: 24px;\n  margin-top: 6px;\n}\n\n.studentName {\n  color: var(--Gray-800, #1f2937);\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  font-family: 'Inter', sans-serif;\n}\n\n.studentEmail,\n.studentMobile {\n  font-size: 14px;\n  color: #6b7280;\n  font-family: 'Inter', sans-serif;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.studentEmail svg,\n.studentMobile svg {\n  flex-shrink: 0;\n}\n\n/* Details Section */\n.detailsSection {\n  margin: 8px 24px;\n  padding: 24px;\n  border-radius: 16px;\n  border: 1px solid var(--Slate-200, #e2e8f0);\n}\n\n.sectionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  font-family: 'Inter', sans-serif;\n}\n\n.relocateButton {\n  color: var(--Violet, #644ee5);\n  text-align: center;\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  padding: 8px 16px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  background-color: #f5f3ff;\n  border: 1px solid var(--Violet-200, #c7d2fe);\n  border-radius: 8px;\n  border: 1px solid var(--Violet, #644ee5);\n  box-shadow: none !important;\n}\n\n.relocateButton:hover {\n  background-color: #644ee5;\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: none;\n}\n\n/* Details Grid */\n.detailsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.detailItem {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 6px;\n  padding: 12px 0;\n  width: 289px;\n}\n\n.detailItem:last-child {\n  border-bottom: none;\n}\n\n.detailLabel {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 400;\n  font-family: 'Inter', sans-serif;\n}\n\n.detailDescription {\n  width: 100%;\n}\n.detailValue {\n  font-size: 14px;\n  color: #1f2937;\n  font-weight: 500;\n  line-height: 20px;\n  font-family: 'Inter', sans-serif;\n}\n.attachmentContainer {\n  width: 100%;\n\n  border-radius: 12px;\n  background: #f1eeff;\n  display: flex;\n  min-width: 175px;\n  padding: 12px 20px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n}\n\n.detailsNameGrid {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Action Button Container - NEW STYLES ONLY */\n.actionButtonContainer {\n  padding: 24px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.resolveButton {\n  background-color: #644ee5 !important;\n  color: white !important;\n  font-weight: 600 !important;\n  padding: 12px 24px !important;\n  border-radius: 8px !important;\n  text-transform: none !important;\n  font-size: 14px !important;\n  font-family: 'Inter', sans-serif !important;\n  transition: all 0.2s ease !important;\n}\n\n.resolveButton:hover {\n  background-color: #644ee5 !important;\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3) !important;\n}\n\n/* Actions Container - Sticky Bottom */\n.actionsContainer {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 676px;\n  max-width: 700px;\n  min-width: 500px;\n  padding: 24px;\n  background-color: white;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 10;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n}\n.attachmentWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.attachmentIcon {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: inline-block;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .modalContent {\n    /* width: 50%; */\n    min-width: 350px;\n  }\n}\n\n@media (max-width: 768px) {\n  .modalContent {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  .modalHeader {\n    padding: 20px 20px 16px 20px;\n  }\n  .avatarSection {\n    justify-content: center;\n  }\n  .avatarSection > div {\n    width: 50%;\n  }\n\n  .studentOverview,\n  .detailsSection {\n    padding: 20px;\n  }\n  .detailsNameGrid {\n    justify-content: flex-start;\n    /* gap; */\n  }\n  .detailsNameGrid > div {\n    width: 50%;\n  }\n  .studentInfo {\n    min-width: 0;\n  }\n  /* .avatarSection {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  } */\n  .detailItem {\n    width: auto;\n  }\n  .actionsContainer {\n    width: 100%;\n    max-width: unset;\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .modalHeader {\n    padding: 16px 16px 12px 16px;\n  }\n  .detailValue {\n    word-wrap: break-word;\n  }\n  .detailsGrid {\n    gap: 0;\n    /* margin-top: 0; */\n  }\n  .studentOverview,\n  .detailsSection {\n    padding: 16px;\n  }\n\n  .resolveButton {\n    padding: 12px 18px;\n  }\n\n  .detailsNameGrid > div {\n    width: 45%;\n  }\n\n  .modalTitle {\n    font-size: 20px;\n  }\n\n  .sectionTitle {\n    font-size: 16px;\n  }\n  .detailsNameGrid {\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n  .studentName {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `viewStudent_modalOverlay__X7kcC`,
	"fadeIn": `viewStudent_fadeIn__0+non`,
	"modalContent": `viewStudent_modalContent__ernub`,
	"slideInRight": `viewStudent_slideInRight__LtMpm`,
	"remarkParent": `viewStudent_remarkParent__o71Cs`,
	"modalHeader": `viewStudent_modalHeader__WQ9UO`,
	"modalTitle": `viewStudent_modalTitle__WOhH2`,
	"statusSection": `viewStudent_statusSection__Wlc6y`,
	"headerRight": `viewStudent_headerRight__qBhjF`,
	"statusChip": `viewStudent_statusChip__UMX6h`,
	"closeButton": `viewStudent_closeButton__rMkOz`,
	"studentOverview": `viewStudent_studentOverview__97H+r`,
	"avatarSection": `viewStudent_avatarSection__gYI4B`,
	"studentAvatar": `viewStudent_studentAvatar__oN2ft`,
	"studentInfo": `viewStudent_studentInfo__7bh2A`,
	"studentInfoBottom": `viewStudent_studentInfoBottom__Ft2jx`,
	"studentName": `viewStudent_studentName__iBqdg`,
	"studentEmail": `viewStudent_studentEmail__ZvxGh`,
	"studentMobile": `viewStudent_studentMobile__H4+qK`,
	"detailsSection": `viewStudent_detailsSection__imrcr`,
	"sectionHeader": `viewStudent_sectionHeader__VvQwu`,
	"sectionTitle": `viewStudent_sectionTitle__Skoa1`,
	"relocateButton": `viewStudent_relocateButton__3Civx`,
	"detailsGrid": `viewStudent_detailsGrid__UouZU`,
	"detailItem": `viewStudent_detailItem__hooCh`,
	"detailLabel": `viewStudent_detailLabel__4KrYk`,
	"detailDescription": `viewStudent_detailDescription__n9w-m`,
	"detailValue": `viewStudent_detailValue__ccZlt`,
	"attachmentContainer": `viewStudent_attachmentContainer__NVnfO`,
	"detailsNameGrid": `viewStudent_detailsNameGrid__pn2z0`,
	"actionButtonContainer": `viewStudent_actionButtonContainer__71Ytt`,
	"resolveButton": `viewStudent_resolveButton__BqSId`,
	"actionsContainer": `viewStudent_actionsContainer__l-te0`,
	"attachmentWrapper": `viewStudent_attachmentWrapper__WD1U6`,
	"attachmentIcon": `viewStudent_attachmentIcon__rX0OS`
};
export default ___CSS_LOADER_EXPORT___;
